/**
 * Was die Instanz über sich sagt: `GET <VITE_CLOUD_API>/api/version` des
 * Kerns liefert `instance_title`, `instance_logo` und `instance_logo_dark`
 * (Vertrag Portal/Cloud, cloud-api 01da6a0). Der Anmeldeschirm zeigt das
 * Kundenlogo unter dem Schriftzug (Post #5421). Ohne `VITE_CLOUD_API` gibt
 * es keine Auskunft und kein Logo.
 */
import { useSyncExternalStore } from 'react'
import { CLOUD_API } from '../config'

interface Instanz { titel: string | null; logo: string | null; logoDunkel: string | null }

let instanz: Instanz = { titel: null, logo: null, logoDunkel: null }
let geladen: Promise<void> | null = null
const hoerer = new Set<() => void>()

/** Der Server prüft den Wert schon; hier noch einmal, weil er in ein `src` wandert. */
export function gueltigesInstanzLogo(wert: unknown): string | null {
  if (typeof wert !== 'string') return null
  if (!wert || wert.length > 500 || /[\s"'<>\\]/.test(wert)) return null
  if (wert.startsWith('https://')) return wert
  // Pfad auf der Instanz selbst; `//host` wäre ein fremder Ursprung.
  if (wert.startsWith('/') && !wert.startsWith('//')) return wert
  return null
}

export function instanzLaden(): Promise<void> {
  if (geladen) return geladen
  geladen = (async () => {
    if (!CLOUD_API) return
    try {
      const ctrl = new AbortController()
      const t = setTimeout(() => ctrl.abort(), 4000)
      const resp = await fetch(`${CLOUD_API}/api/version`, { signal: ctrl.signal }).finally(() => clearTimeout(t))
      if (!resp.ok) return
      const body = (await resp.json()) as { instance_title?: unknown; instance_logo?: unknown; instance_logo_dark?: unknown }
      const logo = gueltigesInstanzLogo(body.instance_logo)
      instanz = {
        titel: typeof body.instance_title === 'string' && body.instance_title.trim() ? body.instance_title.trim() : null,
        logo,
        logoDunkel: logo ? gueltigesInstanzLogo(body.instance_logo_dark) : null,
      }
      hoerer.forEach((fn) => fn())
    } catch {
      /* ohne Auskunft bleibt es beim Zeichen */
    }
  })()
  return geladen
}

function abonnieren(fn: () => void): () => void {
  hoerer.add(fn)
  void instanzLaden()
  return () => { hoerer.delete(fn) }
}

export function useInstanzLogo(): string | null {
  return useSyncExternalStore(abonnieren, () => instanz.logo, () => null)
}
export function useInstanzLogoDunkel(): string | null {
  return useSyncExternalStore(abonnieren, () => instanz.logoDunkel, () => null)
}
export function useInstanzTitel(): string | null {
  return useSyncExternalStore(abonnieren, () => instanz.titel, () => null)
}
